import Vue from "vue";
import axios from "axios";
import NProgress from "nprogress";
import router from '../../router';
import { Notification } from "element-ui";

const state = {
    baseUrlAddr: "https://live.api.nymbleup.com/api/v1",
    productionAddr: "https://live.api.nymbleup.com/api/v1",
    AnalyticsAddr: "https://api.nymbleup.com/api/sales",
};

const mutations = {
    SET_PROD_ADDR(state, prodAddr) {
		state.productionAddr = prodAddr;
	}
};

const actions = {
    getSetBseUrl({ commit }, prodAddr){
        commit("SET_PROD_ADDR", prodAddr);
    },
    serverAddr({ commit }, prodAddr) {
        axios.create({
            baseURL: state.productionAddr,
            timeout: 240000,
            headers: {},
            withCredentials: true,
            transformRequest: [
                function(data, headers) {
                    const access_token = JSON.parse(
                        window.localStorage.getItem("x-access-token")
                    );
                    if (access_token) {
                        headers["Authorization"] = "Bearer" + " " + access_token;
                    }
                    headers["Content-Type"] = "application/json;charset=UTF-8";
                    return JSON.stringify(data);
                }
            ],
            transformResponse: [
                function(data) {
                    if(data){
                        let res = JSON.parse(data);
        
                        if(res.detail && res.detail == "Authentication credentials were not provided."){
                            const r_email = localStorage.getItem('r_email');
                            localStorage.clear();
                            if(r_email){
                            localStorage.setItem('r_email', r_email);
                            }
                            router.push({ path: '/' });
                        }
                    }
                    return data;
                }
            ]
        });
	},
    serverAddrForCSV({ commit }, prodAddr) {
        axios.create({
            baseURL: state.productionAddr,
            timeout: 240000,
            headers: {},
            withCredentials: true,
            transformRequest: [
                function(data, headers) {
                    const access_token = JSON.parse(
                        window.localStorage.getItem("x-access-token")
                    );
                    if (access_token) {
                        headers["Authorization"] = "Bearer" + " " + access_token;
                    }
                    headers["Content-Type"] = "application/json;charset=UTF-8";
                    return JSON.stringify(data);
                }
            ],
            transformResponse: [
                function(data) {
                    if(data){
                        return data;
                    }
                }
            ]
        });
	},
    AnalyticsServerAddr({ commit }, prodAddr) {
        axios.create({
            baseURL: AnalyticsAddr,
            timeout: 50000,
            headers: {},
            withCredentials: true,
            transformRequest: [
                function(data, headers) {
                    const access_token = JSON.parse(
                        window.localStorage.getItem("x-access-token")
                    );
        
                    if (access_token) {
                        headers["Authorization"] = "Bearer" + " " + access_token;
                    }
                    headers["Content-Type"] = "application/json;charset=UTF-8";
                    return JSON.stringify(data);
                }
            ],
            transformResponse: [
                function(data) {
                    return data;
                }
            ]
        });
	},
    fileServerAddr({ commit }, prodAddr) {
        axios.create({
            baseURL: state.productionAddr,
            timeout: 30000,
            headers: {},
            withCredentials: true,
            onUploadProgress: function(progressEvent) {
                NProgress.start();
            },
            transformRequest: [
                function(data, headers) {
                    const access_token = JSON.parse(
                        window.localStorage.getItem("x-access-token")
                    );
        
                    if (access_token) {
                        headers["Authorization"] = "Bearer" + " " + access_token;
                    }
                    return data;
                }
            ],
            transformResponse: [
                function(data) {
                    NProgress.done();
                    return data;
                }
            ]
        });
	},
    extenapiServerAddr({ commit }, prodAddr) {
        axios.create({
            baseURL: state.productionAddr,
            timeout: 6000,
            headers: {},
            withCredentials: true,
            transformRequest: [
                function(data, headers) {
                    const access_token = JSON.parse(
                        window.localStorage.getItem("x-access-token")
                    );
                    if (access_token) {
                        headers["Authorization"] = "Bearer" + " " + access_token;
                    }
                    headers["Content-Type"] = "application/json;charset=UTF-8";
                    return JSON.stringify(data);
                }
            ],
            transformResponse: [
                function(data) {
                    if(data){
                        let res = JSON.parse(data);
                        if(res.detail && res.detail == "Authentication credentials were not provided."){
                            const r_email = localStorage.getItem('r_email');
                            localStorage.clear();
                            if(r_email){
                            localStorage.setItem('r_email', r_email);
                            }
                            router.push({ path: '/' });
                        }
                    }
                    return data;
                }
            ]
        });
	},
};

export default {
	state,
	mutations,
	actions,
	namespaced: true
};
// Network configuration
/*
dispatch.serverAddr.interceptors.request.use(config => {
	NProgress.start();
	return config;
});

dispatch.serverAddr.interceptors.response.use(response => {
	NProgress.done();
	return response;
});
*/